export default __webpack_public_path__ + "static/media/AviciaPortfolio.c00ff6bf.webp";